"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookies = getCookies;
exports.getSwitchUserIdFromCookie = getSwitchUserIdFromCookie;
exports.getSwitchUserTypeFromCookie = getSwitchUserTypeFromCookie;
exports.setSwitchUserIdToCookie = setSwitchUserIdToCookie;
exports.setSwitchUserTypeToCookie = setSwitchUserTypeToCookie;
exports.clearSwitchUserIdCookie = clearSwitchUserIdCookie;
exports.clearSwitchUserTypeCookie = clearSwitchUserTypeCookie;
const constants_1 = require("@aurora/shared-types/developer/constants");
const universal_cookie_1 = __importDefault(require("universal-cookie"));
function getCookies(cookie) {
    return new universal_cookie_1.default(cookie);
}
/**
 * Name of the cookie that will be used to store the ID of impersonated user.
 */
const IMPERSONATED_USER_COOKIE = 'LithiumImpersonatedUser';
/**
 * The path of the cookie that will be used to store the ID of impersonated user.
 */
const IMPERSONATED_USER_COOKIE_PATH = '/';
/**
 * Gets the switched user.
 *
 * @param cookie the cookie string only needed for SSR
 */
function getSwitchUserIdFromCookie(cookie) {
    const id = getCookies(cookie).get(IMPERSONATED_USER_COOKIE);
    if (id) {
        const idAsNumber = Number.parseInt(id);
        if (!Number.isNaN(idAsNumber)) {
            return idAsNumber;
        }
    }
    return null;
}
/**
 * Gets the switched user type.
 *
 * @param sdkEnabled whether the SDK is enabled
 * @param cookie the cookie string only needed for SSR
 */
function getSwitchUserTypeFromCookie(sdkEnabled, cookie) {
    return sdkEnabled ? getCookies(cookie).get(constants_1.SDK_IMPERSONATED_USER_TYPE_COOKIE_NAME) || null : null;
}
/**
 * Function to store the impersonated user's ID on cookie
 *
 * @param userId the impersonated user's ID
 */
function setSwitchUserIdToCookie(userId) {
    const expires = new Date();
    // expire in 30 minutes
    expires.setTime(expires.getTime() + 30 * 60 * 1000);
    getCookies().set(IMPERSONATED_USER_COOKIE, userId, {
        path: IMPERSONATED_USER_COOKIE_PATH,
        expires
    });
}
/**
 * Function to store the impersonated user's type on cookie
 *
 * @param userType the impersonated user's type
 */
function setSwitchUserTypeToCookie(userType) {
    const expires = new Date();
    // expire in 30 minutes
    expires.setTime(expires.getTime() + 30 * 60 * 1000);
    getCookies().set(constants_1.SDK_IMPERSONATED_USER_TYPE_COOKIE_NAME, userType, {
        path: '/',
        expires
    });
}
/**
 * Function to remove the impersonated user's ID cookie
 */
function clearSwitchUserIdCookie() {
    getCookies().remove(IMPERSONATED_USER_COOKIE, { path: IMPERSONATED_USER_COOKIE_PATH });
}
/**
 * Function to remove the impersonated user's type cookie
 */
function clearSwitchUserTypeCookie() {
    getCookies().remove(constants_1.SDK_IMPERSONATED_USER_TYPE_COOKIE_NAME, { path: '/' });
}
//# sourceMappingURL=SwitchUserHelper.js.map